import Vue from 'vue';
import style1 from './style1.vue';

var componentList={
		style1
};
for(var name in componentList){
	Vue.component('productList'+name.replace(/^\w/,function(word){
		return word.toLocaleUpperCase();
	}), componentList[name]);
}